module.exports = __webpack_public_path__ + "static/img/pageTwo.65a22d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageTwo.png
// module id = zIys
// module chunks = 1